    jQuery(window).scroll(function () {
      var topPos = jQuery(this).scrollTop();
      if (topPos > 200) {
        jQuery(".footer-totop-link").addClass("show");
      } else {
        jQuery(".footer-totop-link").removeClass("show");
      }
    });
  
    jQuery(".footer-totop-link").click(function () {
      jQuery("html, body").animate(
        {
          scrollTop: 0,
        },
        800
      );
      return false;
    });


function ProdExistsAdd(prodID) {


    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {



            var exists = false;
            cart.items.forEach(function (item, index) {


                if (item.id == prodID)
                    exists = true;

            });

            if (!exists) {

                $.ajax({
                    type: "GET",
                    url: "/cart/add/?id=" + prodID + "&quantity=1",
                    dataType: "HTML",
                    success: function () {

                        fetchCart();
                    },
                    error: function (error) {
                        addToCartFail();
                    }
                });

            }


        },
    });



}

function legalApprove(e) {
    if (e.checked)
        $(".cart__checkout").prop("disabled", false);
    else
        $(".cart__checkout").prop("disabled", true);
}

function changeErrorMessage(code) {

    console.log('code error');
    if ($('.ucd-discount-error').text().toLowerCase() == code.toLowerCase() + " discount code isn’t valid for the items in your cart") {
        $('.ucd-discount-error').html(code + ' discount code isn’t valid until you have at least 1 more item in your cart. <a href="javascript:;">REMOVE CODE <svg width="12px" height="10px" viewBox="0 0 12 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="MVMT-Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="M---Filter-Tab---Open" transform="translate(-347.000000, -77.000000)" stroke-width="0.5" stroke="#2B2B2B" fill="#2B2B2B"> <g id="Filter---Open" transform="translate(0.000000, 60.000000)"> <polygon id="close-black" points="358 18 357 17 353 21 349 17 348 18 352 22 348 26 349 27 353 23 357 27 358 26 354 22"></polygon> </g> </g> </g> </svg> </a>')
    }

    if ($('.ucd-discount-error').text() != '') {
        $('.ucd-discount-error').show();
    } else {
        $('.ucd-discount-error').hide();
    }

}

var ranOnce = 0;

function equalHeight() {
    $.fn.extend({
        equalHeights: function () {
            var top = 0;
            var row = [];
            var classname = ("equalHeights" + Math.random()).replace(".", "");
            $(this)
                .each(function () {
                    var thistop = $(this).offset().top;
                    if (thistop > top) {
                        $("." + classname).removeClass(classname);
                        top = thistop;
                    }
                    $(this).addClass(classname);
                    $(this).height("auto");
                    var h = Math.max.apply(
                        null,
                        $("." + classname)
                            .map(function () {
                                return $(this).outerHeight();
                            })
                            .get()
                    );
                    $("." + classname).outerHeight(h);
                })
                .removeClass(classname);
        }
    });
    $(".product_care_item .product-title").equalHeights();
    $(".video-section .video-listing-block .video-block").equalHeights();
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

// ingredients childcount
function findLastChild() {
    $('.glossary-details-column.active').removeClass('no-border');
    $('.glossary-details-inner').each(function (index) {
        var column_length = $(this).find('.glossary-details-column.active').length;
        $(this).find('.glossary-details-column.active').each(function (index) {
            if ($(window).width() >= 768) {
                if ((column_length % 2) == 0) {
                    if (index == column_length - 1 || index == column_length - 2) {
                        $(this).addClass('no-border');
                    }
                }
                else {
                    if (index == column_length - 1) {
                        $(this).addClass('no-border');
                    }
                }
            }
            else {
                if (index == column_length - 1) {
                    $(this).addClass('no-border');
                }
            }
        });
    });
}
//Sticky glossary
function stickyGlossary() {
    if ($('.ing-lineup-block')[0]) {

        var textHeight = $('.ing-lineup-block').innerHeight();
        var top_height = textHeight + $('.ing-lineup-block').offset().top - $('#header').innerHeight();
        var glossaryHeight = $('.sticky-glossary-block').innerHeight();
        if ($(window).width() >= 768) {
            if ($(window).scrollTop() > top_height) {
                $('body').addClass('sticky-glossary');
                $('.gds-outer').css('padding-top', glossaryHeight);
            }
            else {
                $('body').removeClass('sticky-glossary');
                $('.gds-outer').css('padding-top', '');
            }
        }
    }
}

function haircolor_accordian() {
    var windowSize = jQuery(window).width();
    jQuery(".hair-color-page .why-obsessed-inner .why-obessed-title").unbind('click').click(function (e) {
        if (windowSize < 992) {
            e.preventDefault();
            $this = jQuery(this).closest(".why-obsessed-inner");
            if ($this.hasClass("active")) {
                $this.removeClass("active");
                $this.find(".be-obsessed-details").stop(true, true).slideUp();
            }
            else {
                $this.addClass("active");
                $this.find(".be-obsessed-details").stop(true, true).slideDown();
            }
        }
    });
}

// ingredients childlength
function checkChild() {
    $('.glossary-details-section').show();
    $(".glossary-letters-listing li").removeClass('no-content');
    $('.glossary-details-inner').each(function () {
        if ($(this).find('.glossary-details-column.active').length == 0) {
            $(this).closest('.glossary-details-section').hide();
            var get_target = $(this).closest('.glossary-details-section').attr("id");
            $(".glossary-letters-listing").find("[data-target='" + get_target + "']").addClass('no-content');
        }
    });
}

// ingredients letterslider
$glossarySlider = false;
function glossary_letters() {
    if ($(window).width() < 992) {
        if (!$glossarySlider) {
            $(".glossary-letters-listing").slick({
                dots: false,
                arrows: true,
                infinite: false,
                slidesToShow: 18,
                slidesToScroll: 5,
                autoplay: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: true,
                responsive: [{
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 18
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 15
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 12
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 7
                    }
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 360,
                    settings: {
                        slidesToShow: 5
                    }
                }
                ]
            });
            $glossarySlider = true;
            $('.glossary-letters-listing .slick-arrow').on('click', function () {
                setTimeout(() => {
                    $(".glossary-letters-listing .slick-track .no-content").attr('aria-hidden', true)
                }, 500);
                setTimeout(() => {
                    $('.glossary-letters-listing .slick-track .slick-active:not(.no-content)')[0].focus();
                }, 100);
            });
        }
    } else if ($(window).width() > 991) {
        if ($glossarySlider) {
            $(".glossary-letters-listing").slick('unslick');
            $glossarySlider = false;
        }
    }
}


//Equal Height Function
equalHeights = function (container) {
    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    jQuery(container).each(function () {
        $el = jQuery(this);
        jQuery($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}


/***Add browser specific class***/


$("a[href='#']").click(function (e) {
    e.preventDefault();
});
var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }

        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else {
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        }
    },

    dataBrowser: [{
        string: navigator.userAgent,
        subString: "Edge",
        identity: "MS Edge"
    },
    {
        string: navigator.userAgent,
        subString: "MSIE",
        identity: "Explorer"
    },
    {
        string: navigator.userAgent,
        subString: "Trident",
        identity: "Explorer"
    },
    {
        string: navigator.userAgent,
        subString: "Firefox",
        identity: "Firefox"
    },
    {
        string: navigator.userAgent,
        subString: "Opera",
        identity: "Opera"
    },
    {
        string: navigator.userAgent,
        subString: "OPR",
        identity: "Opera"
    },

    {
        string: navigator.userAgent,
        subString: "Chrome",
        identity: "Chrome"
    },
    {
        string: navigator.userAgent,
        subString: "Safari",
        identity: "Safari"
    }
    ]
};

BrowserDetect.init();

var bv = BrowserDetect.browser;
if (bv == "Chrome") {
    $("html").addClass("chrome");
} else if (bv == "MS Edge") {
    $("html").addClass("edge");
} else if (bv == "Explorer") {
    $("html").addClass("ie");
} else if (bv == "Firefox") {
    $("html").addClass("Firefox");
}
/***For browser and os specific class***/
var deviceAgent = navigator.userAgent.toLowerCase();

if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
    $('html').addClass('ios');
    $('html').addClass('mobile');
}

if (deviceAgent.match(/android/)) {
    $('html').addClass('android');
    $('html').addClass('mobile');
}

if (deviceAgent.match(/blackberry/)) {
    $('html').addClass('blackberry');
    $('html').addClass('mobile');
}

if (deviceAgent.match(/(symbianos|^sonyericsson|^nokia|^samsung|^lg)/)) {
    $('html').addClass('mobile');
}

function headerAdj() {
    var header_height = $("header").innerHeight();
    $(".wrapper").css("padding-top", header_height);
}


$megamenuflag = false;

// search append in navigation after 1025

var product_flag = false;
var $wrapper_product = $('.product_detail_title_block');

function product_content_append() {
    if ($(window).width() < 992) {
        if (!product_flag) {
            $($wrapper_product).prependTo($('.product-slider .product-slider-left'));
            product_flag = true;
        }
    } else {
        if (product_flag) {
            $(".product-slider .product-slider-right .product-detail-slider_inner").prepend($wrapper_product);
            product_flag = false;
        }
    }
}
// search append in navigation after 1025

var search_flag = false;
var $wrapper = $('.search-input');
//var $offer_text = $('.header-top-right');

function search_content_append() {
    if ($(window).width() < 1200) {
        if (!search_flag) {
            $($wrapper).prependTo($('.header .header-right .serach-mobile'));
            //$('header .header').append($offer_text);
            search_flag = true;
        }
    } else {
        if (search_flag) {
            /*             $(".header .header-right .header-right-topnav li.search-wrapper").append($wrapper);
             */            //$('.header-top-wrapper').append($offer_text);
            search_flag = false;
        }
    }
}

function humber_menu() {
    $(".humber-icon").click(function () {
        if ($(window).width() <= 1199) {
            $("body,html").toggleClass("open-menu");
            jQuery(this).toggleClass("open");
            jQuery(this).attr('aria-label', (_, attr) => attr == 'menu' ? 'close menu' : 'menu');
            $(".nav-menu").stop(true, true).slideToggle();
            if (jQuery('.nav-menu .has-megamenu').hasClass("active")) {
                jQuery('.nav-menu .has-megamenu').removeClass("active");
                jQuery(".megamenu").slideUp();
            } else {
                $(window).trigger('resize');
            }
            $(document).click(function (e) {
                e.stopPropagation();
                if ($(e.target).closest('.nav-menu').length === 0 && $(e.target).closest('.humber-icon').length === 0 && $(e.target).closest('.search-wrapper').length === 0) {
                    $("body,html").removeClass("open-menu");
                    jQuery(".humber-icon").removeClass("open");
                    $(".nav-menu").slideUp();
                }
            });
        }
    });
}

// Slick Slider For Mobile
$slickhomeproduct = false;
function homeproduct_Slider() {
    if ($(window).width() < 768) {
        if (!$slickhomeproduct) {
            $(".home-product-wrapper").not('.slick-initialized').slick({
                dots: true,
                arrows: true,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: true,
                responsive: [{
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
                ]
            });

            $slickhomeproduct = true;

            $('.home-product-wrapper.slick-slider .slick-arrow').on('click', function () {
                setTimeout(() => {
                    $(this).closest('.slick-slider').find('.product_care_item.slick-active').focus();
                }, 100);
            });
        }
    } else if ($(window).width() > 767) {
        if ($slickhomeproduct) {
            $(".home-product-section .home-product-wrapper").slick('unslick');
            $slickhomeproduct = false;
        }
    }
}
function hair_color_tooltip_pos() {
    $('.find-level-section .shades-level-block .shades-listing li').each(function () {
        var tooltip_h = - $(this).find('.hover-text').innerHeight() - 13;
        $(this).find('.hover-text').css({
            top: tooltip_h
        })
    });

}
$slickvideoslider = false;

function haircolorvideo_slider() {
    if (!$slickvideoslider) {
        $(".haircolor-video-section .haircolor-video-slider").slick({
            dots: true,
            arrows: true,
            infinite: false,
            speed: 1000,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: true,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
        $slickvideoslider = true;
        $('.haircolor-video-section .haircolor-video-slider .slick-arrow').on('click', function () {
            ;
            setTimeout(() => {
                $('.haircolor-video-section .haircolor-video-slider .slick-track .slick-active iframe')[0].focus();
            }, 200);
        });
    }

    var banner_slide_length = $('.haircolor-video-section .haircolor-video-slider haircolor-video-item').length;
    if ($(window).width() < 768) {
        if (banner_slide_length < 3) {
            $('.haircolor-video-section .haircolor-video-slider').addClass('no-dots-slider');
        }
        else {
            $('.haircolor-video-section .haircolor-video-slider').removeClass('no-dots-slider');
        }
    }
    else {
        if (banner_slide_length = 1) {
            $('.haircolor-video-section .haircolor-video-slider').addClass('no-dots-slider');
        }
        else {
            $('.haircolor-video-section .haircolor-video-slider').removeClass('no-dots-slider');
        }
    }
}
var $autoplay = true;
function haircolor_autoplay() {
    if ($autoplay) {

        $(".haircolor-video-section .haircolor-video-slider .slick-dots").append("<li class='animated-dot' tabindex='0'><li>");

        $(".haircolor-video-section .haircolor-video-slider .slick-dots li.animated-dot").next("li").remove();
        $autoplay = false;
    }
    $(".haircolor-video-section .haircolor-video-slider .slick-dots .animated-dot").click(function () {
        $(this).toggleClass("play");
        if ($(this).hasClass("play")) {
            $('.haircolor-video-section .haircolor-video-slider').slick('slickPause');
        } else {
            $('.haircolor-video-section .haircolor-video-slider').slick('slickPlay');
        }
    });
}
$slickhomeabout = false;

function homeabout_Slider() {
    //if ($(window).width() < 768) {
    if (!$slickhomeabout) {
        $(".services-image-wrapper").slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 1000,
            slidesToShow: 3,//2.3
            slidesToScroll: 1,
            autoplay: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: true,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2.3,
                        dots: true,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        arrows: true,
                    }
                }
            ]
        });
        $slickhomeabout = true;
    } else if ($(".services-image-wrapper")[0]) {
        // console.log($(".services-image-wrapper")[0]);
        $(".services-image-wrapper").slick('resize');
        // $(".services-image-wrapper")[0].slick.refresh();
    }
    //     } else if ($(window).width() > 767) {
    //         if ($slickhomeabout) {
    //             $(".services-image-wrapper").slick('unslick');
    //             $slickhomeabout = false;
    //         }
    //     }
}
$slickhomeblog = false;

function blog_Slider() {
    if ($(window).width() < 768) {
        if (!$slickhomeblog) {
            $(".home-blog .home-blog-content .row").slick({
                dots: true,
                arrows: true,
                infinite: false,
                speed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: true,
                responsive: [{
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
                ]
            });
            $slickhomeblog = true;
        }
    } else if ($(window).width() > 767) {
        if ($slickhomeblog) {
            $(".services-image-wrapper").slick('unslick');
            $slickhomeblog = false;
        }
    }
}

function hideDots() {
    if ($('.product_care.slick-slider').length) {
        var slider_count = $('.product_care.slick-slider').length;
        var aslide_count = $('.product_care_item.slick-active').length / slider_count;
        var tslide_count = $('.product_care_item.slick-slide').length / slider_count;
        if (aslide_count <= 2) {
            if (tslide_count <= 2) {
                if ($(window).width() >= 576) {
                    $('.product_care .slick-dots').hide();
                }
            }
        }
    }
}

// product-category slider start
var product_cat_slider = false;

function product_category_slider() {
    if ($(window).width() <= 767) {
        if (!product_cat_slider) {
            $('.product_care').on('init', function (event, slick) {
                if ($(window).width() > 575) {
                    if (slick.slideCount <= 2) {
                        $('.product_care .slick-dots').hide();
                    }
                }
            });


            $(".product_care").slick({
                arrows: true,
                dots: true,
                infinite: false,
                speed: 1000,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: true,
                responsive: [{
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
                ]
            });
            product_cat_slider = true;
        }
    } else if ($(window).width() >= 768) {
        if (product_cat_slider) {
            $(".product_care").slick('unslick');
            product_cat_slider = false;
        }
    }
}
// product-category slider end
var homeCare_product_wrapper = false;

function home_care_product_wrapper() {
    if ($(window).width() < 768) {
        if (!homeCare_product_wrapper) {
            $(".home-care-product-wrapper").slick({
                dots: true,
                arrows: true,
                infinite: false,
                speed: 1000,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: true,
                responsive: [{
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
                ]
            });
            homeCare_product_wrapper = true;
        }
    } else if ($(window).width() > 767) {
        if (homeCare_product_wrapper) {
            $(".home-care-product-wrapper").slick('unslick');
            homeCare_product_wrapper = false;
        }
    }
}

function quiz_list_offset() {
    $(".hair-care-why-choose .bottom-block .bottom-block-inner ul li").each(function () {
        var _this = $(this);
        _this.prepend("<em></em>");
    })
}

function formulasDropdown(toggleEvent, jump) {

    if (jump)
        $("body ,html").animate({ scrollTop: $('.formulas-slider-content').offset().top - 200 }, 500);

    jQuery(".mobile-formulas-dropdown ul li").each(function () {
        var data_id = jQuery(this).data("id");
        var data_id_text = jQuery(this).text();
        if (toggleEvent == data_id) {
            jQuery(".mobile-formulas-dropdown span").text(data_id_text);
        }
    });
}

var shade_flag = false;

function shade_list_function() {
    if ($(window).width() < 768) {
        if (!shade_flag) {
            var shade_list = $('.shade_name');
            var elem_txt = $('.shade-item-mobile');
            elem_txt.click(function (e) {
                e.preventDefault();
                shade_list.slideDown(200);
                elem_txt.addClass("arrow-down");
            });
            shade_list.find('li').click(function () {
                var title_id = $(this).attr("data-toggle");
                $(this).addClass("active").siblings().removeClass("active");
                var text = $(this).html();
                elem_txt.html(text);
                shade_list.slideUp(200);
                elem_txt.removeClass("arrow-down");
                $("#" + title_id).click();
            });
            shade_flag = true;
        }
    } else {
        shade_flag = false;
    }
}

$(".shade-item").focus(function () {
    $(this).click();
})

$(".formulas-slider-nav .slide-img, .slide-location-nav").focus(function () {
    $(this).click();
})
var flag = true;

function account_mble_menu() {

    if ($(window).width() < 768) {
        if (flag) {
            $(".myaccount-order-page .my-account-inner-wrapper .left-account-menu li.active").append("<em class='mble-arrow'></em>");
            flag = false;
            $(".myaccount-order-page .my-account-inner-wrapper .left-account-menu .active .mble-arrow").on("click", function () {
                $(this).closest(".left-account-menu").toggleClass("left-account-menu-open");

            });
        }
    } else {
        $(".myaccount-order-page .my-account-inner-wrapper .left-account-menu li.active em").remove();
        flag = true;
    }
}
var blog_flag = true;
function blog_mble_menu() {


    if ($(window).width() < 768) {
        if (blog_flag) {
            $(".blog-heading-section .blog-tab-listing li.active").append("<em class='mble-arrow'></em>");
            blog_flag = false;
            $(".blog-heading-section .blog-tab-listing li.active .mble-arrow").on("click", function () {
                $(this).closest(".blog-tab-listing").toggleClass("listing-open");
            });
            $(".blog-heading-section .tab-listing-outer").append("<ul class='search-bar'></ul>")
            $(".blog-heading-section .blog-tab-listing .search-link").detach().appendTo(".blog-heading-section .tab-listing-outer .search-bar");
        }
    } else {
        $(".blog-heading-section .blog-tab-listing li.active em").remove();
        $(".blog-heading-section .search-link").detach().appendTo(".blog-heading-section .tab-listing-outer .blog-tab-listing");
        $(".blog-heading-section .tab-listing-outer .search-bar").remove();
        blog_flag = true;
    }
}
function changeImageTitle() {
    $(".shade-item").click(function () {
        var product_img = $(this).attr("data-product-image");
        var product_demo_img = $(this).attr("data-product-demo");
        var product_title = $(this).attr("data-product-title");
        $(".shade-item").removeClass("active");
        $(this).addClass("active");
        $('.shades-product img').attr('src', product_img);
        $('.shades-women img').attr('src', product_demo_img);
        $("#" + product_title).addClass("active").siblings().removeClass("active");
        var shade_title = $("#" + product_title).html();
        $(".item-list-mobile").html(shade_title);
    });
}

function count_left_distunce() {
    if ($(".categroy-item h2").length) {
        $(".categroy-item").each(function () {
            var _this = $(this);
            var left_distance = _this.find("h2").offset().left + _this.find("h2").width() + 16;
            var max_width = "calc(100vw - " + left_distance + "px)";
            _this.find(".strip-block").css("width", max_width);

        })
    }
}

function addTocart() {
    var modal_height = $(".ajax-cart-drawer__buttons").innerHeight() + 250;
    if (modal_height > $(window).height()) {
        $("body,html").addClass("height-overflow");
    } else {
        $("body,html").removeClass("height-overflow");
    }
}

function quiz_step_validation(input_id) {
    var _this = $(input_id);
    var input_val = _this.val();
    var valid = true;


    if (input_id == '#email') {
        if (!validateEmail(input_val)) {
            _this.parent().find(".form-control").addClass("input--error");
            _this.parent().find(".error-message").removeClass("hide");
            _this.focus();
            valid = false;
            return valid;
        }
    }

    if (input_id == '#policyCheck') {
        if (_this.is(':checked') || input_val == 'true_logged') {

        }else{
            _this.parent().find(".form-control").addClass("input--error");
            _this.parent().find(".error-message").removeClass("hide");
            _this.focus();
            valid = false;
            input_val = ""
        }
    }


    if (input_val == "") {
        _this.parent().find(".form-control").addClass("input--error");
        _this.parent().find(".error-message").removeClass("hide");
        _this.focus();
        valid = false;
    } else {
        _this.parent().find(".form-control").removeClass("input--error");
        _this.parent().find(".error-message").addClass("hide");
        valid = true;
    }

    return valid;
}

// fix_header

var header_flag = true;

function fix_header() {
    if ($(window).scrollTop() > ($('.main-content').offset().top - 25)) {
        if (header_flag) {
            $('body').addClass('stickey-header');
            $('.stickey-header header').css('top', -150 + 'px');
            setTimeout(function () {
                $('.stickey-header header').css('top', 0);
            }, 200);
            header_flag = false;
        }
    } else {
        $('body').removeClass('stickey-header');
        $('header').css('top', '');
        setTimeout(function () {
            $('header').css('top', '');
        }, 200);
        header_flag = true;
    }
}

var nav_flag;

function desktop_menu() {
    if ($(window).width() >= 1200) {
        if (nav_flag) {
            if ($('.has-megamenu').hasClass('active')) {
                $('.has-megamenu').removeClass('active');
            }
            if ($('html,body').hasClass('open-menu')) {
                $('html,body').removeClass('open-menu');
            }
            if ($('.humber-icon').hasClass('open')) {
                $('.humber-icon').removeClass('open');
            }

            $('.megamenu').css('display', '');
            $('.nav-menu').css('display', '');
            $(".has-megamenu").on('mouseenter', function (e) {
                e.preventDefault();
                $(this).addClass('open');
                var submenu = $(this).closest('li').find('.megamenu');
                if ($(this).hasClass('open')) {
                    $(submenu).slideDown(400);
                }
            }).on('mouseleave', function (e) {
                e.preventDefault();
                $(this).removeClass('open');
                var submenu = $(this).closest('li').find('.megamenu');
                if ($(submenu).is(':visible')) {
                    $(submenu).stop(true, true).slideUp(400);
                }
            });
            $(".header .header-right nav>ul>li>a").focus(function (e) {
                e.preventDefault();
                $(this).addClass('open');
                var submenu = $(this).closest('li').find('.megamenu');
                $(this).closest('li').siblings().find('.megamenu').stop(true, true).slideUp(400);
                if ($(this).hasClass('open')) {
                    $(submenu).slideDown(400);
                }
            });

            nav_flag = false;
        }
    } else {
        if (!nav_flag) {
            $(".has-megamenu").unbind('click').on('click', function (e) {
                if (!e.target.classList.contains('heading_left') && e.target.classList.contains('nav-menu-item__title')) {
                    if (jQuery(this).hasClass("active")) {
                        jQuery(this).removeClass("active");
                        jQuery(this).find(".megamenu").stop(true, true).slideUp();
                    } else {
                        jQuery('.has-megamenu').removeClass("active");
                        jQuery(".megamenu").slideUp();
                        jQuery(this).addClass("active");
                        $(this).find(".megamenu").slideDown();
                    }
                }
            });
            nav_flag = true;
        }

    }
}

var tooltip_flag = true;

function hair_color_tooltip() {
    if ($(window).width() > 1024) {
        if (tooltip_flag) {

            $(".find-level-section .shades-level-block .shades-listing li").on('mouseenter', function (e) {
                $(this).closest('.shades-listing').addClass('introduction-text-hide');
                var tooltip_h = - $(this).find('.hover-text').innerHeight() - 13;
                $(this).find('.hover-text').css({
                    top: tooltip_h
                });
                $(this).addClass('active');
                $(this).siblings().removeClass('active');

            }).on('mouseleave', function (e) {
                $(this).removeClass('active');

            });
            $(".find-level-section .shades-level-block .shades-listing li").focus(function (e) {
                $(this).closest('.shades-listing').addClass('introduction-text-hide');
                var tooltip_h = - $(this).find('.hover-text').innerHeight() - 13;
                $(this).find('.hover-text').css({
                    top: tooltip_h
                });
                $(this).addClass('active');
                $(this).siblings().removeClass('active');
            });

            tooltip_flag = false;
        }
    }
    else if ($(window).width() <= 1024) {

        $(".find-level-section .shades-level-block .shades-listing li").unbind('click').on('click', function (e) {
            // e.preventDefault();
            $(this).closest('.shades-listing').addClass('introduction-text-hide');
            var tooltip_h = - $(this).find('.hover-text').innerHeight() - 13;
            $(this).find('.hover-text').css({
                top: tooltip_h
            });
            $(this).toggleClass('active');
            $(this).siblings().removeClass('active');
        });
        tooltip_flag = true;
    }
}

function desktopClass() {
    if ($(window).width() >= 1200) {
        $('nav').addClass("desk").removeClass('mob');
        $('.has-megamenu').unbind('click');
        $('.has-megamenu').bind('mouseenter mouseleave');
    } else {
        $('nav').removeClass("desk").addClass('mob');
        $('.has-megamenu').unbind('mouseenter mouseleave');
        $('.has-megamenu').bind('click');
    }
}

// for eyebrow_menu
function eyebrow_menu() {
    if ($(window).width() >= 1200) {
        if ($('body').hasClass('stickey-header')) {
            $('.header .header-right .header-right-topnav li.cart-bag').appendTo('.nav-menu.desk>ul');
        } else {
            $('.nav-menu.desk ul li.cart-bag').appendTo('.header .header-right .header-right-topnav');
        }
    } else {
        $('.nav-menu.desk ul li.cart-bag').appendTo('.header .header-right .header-right-topnav');
    }
}

// for cart
function cart_item_height() {

    if ($('.ajax-cart__drawer').length) {
        var cart_footer = $('.ajax-cart-footer').outerHeight(true);
        var cart_height = $('.ajax-cart__drawer').outerHeight(true);

        setTimeout(function () {
            $('.cart-drawer-wrapper').css('height', 'calc(' + cart_height + 'px - ' + cart_footer + 'px)');
        }, 110);
    }
}

// Instruction slider function
function init_class(current, last, class_nm) {
    if (jQuery('.product-detail-instruction-wrapper .instruction-listing-slider.slick-slider').length) {
        var currentItem = current;
        var last_item = last - 1;
        if (currentItem >= 1 && currentItem != last_item) {
            class_nm.addClass("init-slide");
        }
        if (jQuery(class_nm).find(".slick-slide[data-slick-index='" + last_item + "']").attr('aria-hidden') != 'true') {
            class_nm.addClass("init-slide-last");
            class_nm.removeClass("init-slide");
        } else {
            // class_nm.removeClass("init-slide");
            class_nm.removeClass("init-slide-last");
        }
    }
}



/***Document Ready***/
$(document).ready(function () {

    haircolor_accordian();
    haircolorvideo_slider();
    haircolor_autoplay();
    hair_color_tooltip_pos();
    $(".haircolor-video-section .haircolor-video-slider .slick-dots li.animated-dot").click(function () {
        $(this).toggleClass('play');
    });
    //For Upsell model
    $("#upsellModal").on('hide.bs.modal', function () {
        setTimeout(function () {
            if (!$(".ajax-cart__drawer").hasClass("is-open"))
                addToCartOk();
        }, 400);

    });

    if ($('.find-level-section .shades-level-block .shades-listing').length) {
        $('.find-level-section .shades-level-block .shades-listing li:first-child').addClass('active');
    }

    $("#upsellModal").on('show.bs.modal', function () {
        if (jQuery("#upsellModal .home-product-wrapper").length) {
            if (jQuery(window).width() < 768) {
                $('#upsellModal .home-product-wrapper').slick('destroy');
                setTimeout(function () {
                    $('#upsellModal .home-product-wrapper').slick({
                        dots: true,
                        arrows: true,
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        autoplay: false,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        adaptiveHeight: true,
                        responsive: [{
                            breakpoint: 9999,
                            settings: "unslick"
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                        ]

                    });
                }, 200);

                setTimeout(function () {
                    equalHeights(".upsell-modal .product_care_item .upsell-product-title h3");
                }, 3000);

            }

        }

    });

    $(document).on("click", ".selected-item-div", function () {
        $(this).toggleClass("active");
        
                if ($(this).find(".shades-content-list").is(":visible")) {
            $(this).find(".shades-content-list").css("display", "");
        }
        else {
            $(this).find(".shades-content-list").css("display", "block");
        }
        
        
        if (!$(this).hasClass('active')) {
            $(".selected-item-wrap").css("display", "");
        }
        else {
            $(".selected-item-wrap").css("display", "block");
        }
    });



    $(".selected-item-div .shades-content-list li").on("click", function () {
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
        var _text = $(".selected-item-div .shades-content-list li.active span").clone();
        $(".selected-item-div > span").remove();
        $(".selected-item-div").prepend(_text);
    });
    
    
    
    $(".selected-item-wrap .shades-content-list li").on("click", function () {
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
        $(".selected-item-wrap").removeClass("active");
        $(".selected-item-wrap").css("display", "");

        $(".selected-item-div span").text($(this).text());
    });

    $('.selected-item-wrap input').on('keyup', function() {
        var key = $(this).val().toLowerCase();
        console.log(key);
        $(".selected-item-wrap .shades-content-list li").each(function(){
            var text = $(this).text().toLowerCase();
            if(text.indexOf(key) > -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        })
    })

    $('.lessMore-shades').on('click', function(){
        $('.product-slider-row .product-slider-tabbing').toggleClass('more');

     
 
      if($(this)[0].innerText == '+ See More Colors')
          $(this)[0].innerText = '- See Less Colors';
      else
         $(this)[0].innerText ='+ See More Colors';
    })


    $('a[href^="#"]').on('click', function (event) {
        var target = $(this.getAttribute('href'));
        if (target.length) {

            srollTo(target);

        }
    });



    $('.product-slider-tabbing ul li a').click(function (e) {
        e.preventDefault();
        var _this = $(this);
        var _this_link = $(this).attr('data-link');
        _this.closest('li').addClass('active').siblings().removeClass('active');
        _this.closest('.product-slider-row').find('.custom-product-slider-block .product-slider-inner[data-content="' + _this_link + '"]').addClass('active').siblings().removeClass('active');
        //     _this.closest('.product-slider-row').find('.custom-product-slider-block .product-slider-inner[data-content="' + _this_link + '"]').find(".slider-single").slick("refresh");
        //	_this.closest('.product-slider-row').find('.custom-product-slider-block .product-slider-inner[data-content="' + _this_link + '"]').find(".slider-nav").slick("refresh");

    });



    $(".product-detail-instruction-wrapper .instruction-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        adaptiveHeight: true,
        infinite: false,

    });


    $(".product-detail-instruction-wrapper .instruction-slider").on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;

        $(this).closest(".product-detail-instruction-wrapper").find('.instruction-listing li').eq(mySlideNumber).addClass('active').siblings().removeClass('active');
        $(this).closest(".product-detail-instruction-wrapper").find('.mobile-progress .current').text(mySlideNumber + 1);

        var pos = $('.product-detail-instruction-wrapper .instruction-listing li.active').position().left;
        var currentscroll = $(".product-detail-instruction-wrapper .instruction-listing").scrollLeft(); // get current scroll position
        var divwidth = $(".product-detail-instruction-wrapper .instruction-listing").width(); //get div width
        pos = (pos + currentscroll) - (divwidth / 2); // for center position if you want adjust then change this

        $('.product-detail-instruction-wrapper .instruction-listing').animate({
            scrollLeft: pos
        });
    });
    $('.product-detail-instruction-wrapper .instruction-listing li').click(function () {
        var _this = $(this);
        var _this_index = $(this).index();
        _this.addClass('active').siblings().removeClass('active');
        _this.closest(".product-detail-instruction-wrapper").find('.instruction-slider .slick-dots li').eq(_this_index).find('button').trigger('click');

    })
    if ($('.product-detail-instruction-wrapper .instruction-listing li').length) {
        var total_progress_item = $('.product-detail-instruction-wrapper .instruction-listing li').length;
        $('.product-detail-instruction-wrapper .mobile-progress .total').text(total_progress_item);
        $('.product-detail-instruction-wrapper .mobile-progress .current').text(1);
    }
    $('.product-detail-instruction-wrapper .instruction-listing li,.product-detail-instruction-wrapper .instruction-slider .slick-arrow').focus(function () {
        $(this).trigger('click');
    })

    //         hair color detail page end//





    $(".profile-desc .more-hider").click(function () {
        // console.log('here');
        $(this).parent().find("p").not(":first").hide();
        $(this).parent().find(".more-hider").hide();
        $(this).parent().find(".more-shower").show();
    });

    $(".profile-desc .more-shower").click(function () {
        $(this).parent().find("p").show();
        $(this).parent().find(".more-shower").hide();
        $(this).parent().find(".more-hider").show();
    });



    $('.profile-desc').each(function () {


        paragraphCount = $(this).find("p").size();


        $(this).find(".more-hider").hide();
        $(this).find(".more-shower").hide();
        //console.log(paragraphCount);
        if (paragraphCount > 1) {
            $(this).find(".more-shower").show();
        }

        $(this).find("p").not(":first").hide();

    });

    //for password reset message
    if ($('.form-message--success').is(':visible')) {
        $('.form-message--success').addClass('visible');
        setTimeout(function () {
            $('.form-message--success').removeClass('visible');
        }, 4000);
    }

    var $videoSrc;

    $('.video-section a.video-link').click(function () {
        $videoSrc = $(this).data("src");
    });


    $('.video-section .video-listing-block a.video-link').click(function () {
        $videoSrc = $(this).data("src");
    });
    $('#video-modal').on('shown.bs.modal', function (e) {
       

        if(!!window.OnetrustActiveGroups.includes(BVperformanceCookieCategory) == false){
        
        $('#video').attr('data-src', $videoSrc + "?rel=0&autoplay=0&amp;modestbranding=1&amp;showinfo=0");
        $('#video').attr('src','');
        $('#video-modal iframe').wrap( "<div class='youtubeVideo'></div>" );
        $('#video-modal iframe').before('<div class="warning-youtube"><img src="https://cdn.shopify.com/s/files/1/0231/9600/8495/t/90/assets/play-btn%201.png"/><p>Please accept cookies in order to play this video.</p><button id="ot-sdk-btn" class="ot-sdk-show-settings" onclick="OneTrust.ToggleInfoDisplay()">Cookie Settings</button></div>');
        
      }else{
           $('#video').attr('src', $videoSrc + "?rel=0&autoplay=1&amp;modestbranding=1&amp;showinfo=0");
          $('.warning-youtube').remove();
      }
      
      
      
      


      

     
    });

    $('#video-modal').on('hide.bs.modal', function (e) {
        $("#video").attr('src', '');
    });

    desktopClass();

    if ($("nav").hasClass("desk")) {
        nav_flag = true;
    }
    if ($("nav").hasClass("mob")) {
        nav_flag = false;
    }


    count_left_distunce();
    addTocart();
    quiz_list_offset();
    hideDots();
    eyebrow_menu();

    $('.modal').on('shown.bs.modal', function (e) {
        // $(window).trigger("resize");
        $('.slider-for, .slider-nav').slick('refresh');
    });
    $(".addtocart-side-drawer .ajax-cart-drawer__close, .ajax-cart__overlay").on("click", function () {
        $("body,html").removeClass("addtocart");
        $(".ajax-cart__drawer").removeClass("is-open");
        $(".ajax-cart__overlay").removeClass("is-open");
    });

    $(document).keydown(function (event) {
        if (event.keyCode == 27) {
            $("body,html").removeClass("addtocart");
            $("html").removeClass("is-locked");
            $(".ajax-cart__drawer").removeClass("is-open");
            $(".ajax-cart__overlay").removeClass("is-open");
            $(".ajax-cart__modal").removeClass("is-open");



            $('#welcomeModal').modal("hide");
            $(".modal").modal('hide');

            // for search
            if ($(window).innerWidth() <= 1199) {
                $(".search-input").fadeOut();
                $(".search-input input#search").blur();
                $(".search-input input#search").val('');

                //for mobile-menu
                if ($('.nav-menu').is(':visible')) {
                    $(".humber-icon").trigger('click');
                }
            } else {
                $(".search-wrapper").removeClass('show-search');
                $(".search-input input#search").val('');
                $(".search-input input#search").blur();
            }
            $(".blog-heading-section .search-link").removeClass("search-result-open");
            $(".blog-heading-section .search-link .search-btn").hide();
            $(".blog-heading-section .search-link .search-span").show();
        }
    });

    // ingredients glossary js
    findLastChild();
    checkChild();
    glossary_letters();
    stickyGlossary();

    $('.glossary-letters-listing li').on('click', function () {

        var data = $(this).attr('data-target');
        setTimeout(() => {
            console.log($(`#${data} .glossary-details-column`)[0]);
            $(`#${data} .glossary-details-column`)[0].focus();
        }, 100);
    })

    $(".ing-glossary-page .glossary-details-inner .ing-black").fadeIn(600).addClass('active fadeInGloss animated');
    $(".ing-glossary-page .glossary-details-inner .ing-green").fadeIn(600).addClass('active fadeInGloss animated');

    $('.ing-glossary-page .natural-btn').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        //         $(".gds-inner").removeClass("go");
        if ($(this).hasClass('active')) {
            $(".ing-glossary-page .glossary-details-inner .ing-black").fadeOut(200).removeClass('active fadeInGloss animated');
            $(".ing-glossary-page .glossary-details-inner .ing-green").fadeIn(600).addClass('active fadeInGloss animated');
        }
        //         setTimeout(function(){
        //             $(".gds-inner").addClass("go");
        //         },400);
        findLastChild();
        checkChild();

    });
    $('.ing-glossary-page .pure-btn').click(function () {
        //         $(".gds-inner").removeClass("go");
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('active')) {
            $(".ing-glossary-page .glossary-details-inner .ing-green").fadeOut(200).removeClass('active fadeInGloss animated');
            $(".ing-glossary-page .glossary-details-inner .ing-black").fadeIn(600).addClass('active fadeInGloss animated');
        }
        //         setTimeout(function(){
        //             $(".gds-inner").addClass("go");
        //         },100);
        findLastChild();
        checkChild();
    });
    $('.ing-glossary-page .show-all').click(function () {
        //         $(".gds-inner").removeClass("go");
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('active')) {
            $(".ing-glossary-page .glossary-details-inner .ing-green").fadeIn(600).addClass('active fadeInGloss animated');
            $(".ing-glossary-page .glossary-details-inner .ing-black").fadeIn(600).addClass('active fadeInGloss animated');
        }
        //         setTimeout(function(){
        //             $(".gds-inner").addClass("go");
        //         },100);
        findLastChild();
        checkChild();
    });
    $('.glossary-letters-listing li').on('click', function () {
        var get_id = $(this).data("target");
        $(".glossary-details-section").each(function () {
            if (get_id == $(this).attr("id")) {
                var contentTop = $(this).offset().top;
                var headerHeight = $('#header').innerHeight() - 30;
                var glossaryHeight = $('.sticky-glossary-block').innerHeight();
                var total_Height = glossaryHeight + headerHeight;
                var contentTopscroll = contentTop - total_Height;
                var mobileTopscroll = contentTop - headerHeight;
                if ($(window).width() >= 768) {
                    $("body ,html").animate({ scrollTop: contentTopscroll }, 1000);
                }
                else {
                    $("body ,html").animate({ scrollTop: mobileTopscroll }, 1000);
                }
            }
        });

    });
    $('.glossary-letters-listing .all-link').click(function () {
        var sectionTopval = $('.gds-outer').offset().top;
        var headerHeight = $('#header').innerHeight() - 10;
        var contentTopscroll = sectionTopval - headerHeight;
        $("body ,html").animate({ scrollTop: contentTopscroll }, 1000);
    });

    $(window).on("orientationchange", function () {
        setTimeout(function () {
            if ($('.glossary-letters-listing.slick-slider').length) {
                $('.glossary-letters-listing').slick('resize');
            }
        }, 200);
        glossary_letters();

    });
    if ($('.custom-select-dropdown select').length) {
        $('.custom-select-dropdown select').select2();
    }

    // Top adjestment of megamenu according header height
    // megamenuAdj();

    humber_menu();
    search_content_append();
    product_content_append();
    changeImageTitle();
    shade_list_function();
    account_mble_menu();
    desktop_menu();
    hair_color_tooltip();
    blog_mble_menu();

    if ($(".quiz-step-content-block").length) {
        $("<span class='step_navigation'>Title</span>").insertBefore(".quiz-step-content-block");
    }


    $(".quiz-section .quiz-inner-content .next-btn").click(function () {
       /* var valid = quiz_step_validation('#user-name');

        var valid2 = quiz_step_validation('#email');

        var policy = quiz_step_validation('#policyCheck')
*/


        //if (valid == true && valid2 == true && policy == true) {

            $(this).closest(".quiz-inner-content").hide();
            $(this).closest(".quiz-inner-content").next(".quiz-inner-content").show();
        //}
        $('.quiz-section').addClass('Quiz__start');
    });
    $(".custom-input .form-control").on("keyUp change input", function () {
        var _this = $(this).attr("id");
        quiz_step_validation('#' + _this);
    });

    if ($(".previous-content").length > 0) {
        $(document).on("click", ".previous-content .back-step a", function () {
            $(".quiz-inner-content").hide();
            $(".quiz-inner-content.wizard-01").show();
            $('.quiz-section').removeClass('Quiz__start');
        });
    }
    // Search open
    $(".search-wrapper").on("click", function () {
        if ($(window).width() <= 1199) {
            $(".search-input").stop(true, true).fadeToggle();
            $(".search-input input#search").focus();
        } else {
            $(this).addClass('show-search');
            $(".search-input input#search").focus();
        }
    });


    if ($('#welcomeModal').length) {
        $('.close').click(function () {
            $('#welcomeModal').modal("hide");
        });
    }

    //       if($(window).width()<768) {
    //       $(".myaccount-order-page .my-account-inner-wrapper .left-account-menu li.active").
    //       }

    $(".blog-heading-section .search-link .search-span").on('click', function (e) {
        e.stopPropagation();
        $(this).hide();
        $(this).closest(".search-link").find(".search-btn").show();
        $(this).closest(".search-link").addClass("search-result-open");
        $(this).closest(".search-link").find('.form-control').focus();
        $(".blog-heading-section .blog-tab-listing").removeClass("listing-open");
    });

    $(document).click(function (e) {
        e.stopPropagation();
        if ($(e.target).closest('.search-link').length === 0) {
            $(".blog-heading-section .search-link").removeClass("search-result-open");
            $(".blog-heading-section .search-link .search-btn").hide();
            $(".blog-heading-section .search-link .search-span").show();
        }
    });
    $(document).click(function (e) {
        e.stopPropagation();
        if ($(e.target).closest('.blog-tab-listing').length === 0) {
            $(".blog-heading-section .blog-tab-listing").removeClass("listing-open");

        }
    });
    $(document).click(function (e) {
        e.stopPropagation();
        if ($(e.target).closest('.search-input').length === 0 && $(e.target).closest('.search-wrapper').length === 0) {
            if ($(".search-input").is(':visible')) {
                if ($(window).innerWidth() <= 1199) {
                    $(".search-input").fadeOut();
                    $(".search-input input#search").blur();
                    $(".search-input input#search").val('');
                } else {
                    $(".search-wrapper").removeClass('show-search');
                    $(".search-input input#search").val('');
                    $(".search-input input#search").blur();
                }
            }
        }
    });

    fix_header();

    homeabout_Slider();
    blog_Slider();
    product_category_slider();

    setTimeout(function () {
        homeproduct_Slider();
    }, 500);

    // home_care_product_wrapper();
    equalHeight();
    equalHeights(".home-product-section .home-product-wrapper .home-product-outer .home-product-image");
    equalHeights(".ing-details .ing-img");
    equalHeights(".home-product-section .home-product-wrapper .home-product-outer .home-product-content");
    equalHeights(".formulas-slider-nav .slide-img");
    equalHeights(".product_care_item .product_care-inner");

    // equalHeights(".product_care_item .product-title");

    // $(window).trigger("resize");


    equalHeights(".product_care_item .home-product-inner-wrapper");
    // blog page
    setTimeout(function () {
        equalHeights(".upsell-modal .product_care_item .upsell-product-title h3");
        equalHeights(".blog-page .feature-grid-block h3");
    }, 1000);
    //   setTimeout(function(){
    //   	equalHeights(".upsell-modal .product_care_item .upsell-product-title h3");
    //   },200);

    jQuery('.formulas-slider-content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.formulas-slider-nav',
        arrows: false,
        fade: true,
        lazyLoad: 'ondemand',
        autoplay: false,
        touchMove: false,
        draggable: false,
        swipe: false,
        accessibility: true,
        adaptiveHeight: true
    });

    jQuery('.formulas-slider-nav').slick({
        slidesToShow: 13,
        slidesToScroll: 13,
        asNavFor: '.formulas-slider-content',
        dots: false,
        lazyLoad: 'ondemand',
        centerMode: false,
        focusOnSelect: true,
        infinite: false,
        arrows: false,



        accessibility: true,
        // variableWidth: true,
        responsive: [{
            breakpoint: 755,
            settings: {
                dots: true,
                arrows: true,
                slidesToShow: 10,
                slidesToScroll: 10,
            }
        },
        {
            breakpoint: 567,
            settings: {
                dots: true,
                arrows: true,
                slidesToShow: 8,
                slidesToScroll: 8,
            }
        },
        {
            breakpoint: 375,
            settings: {
                dots: true,
                arrows: true,
                slidesToShow: 5,
                slidesToScroll: 5,
            }
        }
        ],
    });

    // mobile formulas dropdown
    if (jQuery(".slide-img").hasClass("slick-current")) {
        var data_toggle = jQuery(".slide-img.slick-current").data("toggle");
        formulasDropdown(data_toggle, false);



    }

    jQuery(".slide-img").click(function () {
        var data_toggle = jQuery(this).data("toggle");
        formulasDropdown(data_toggle, true);
        jQuery(this).addClass("slick-current").siblings().removeClass("slick-current");


    });

    jQuery(".formulas-slider .slick-dots").click(function () {
        if (jQuery(".slide-img").hasClass("slick-current")) {
            var data_toggle = jQuery(".slide-img.slick-current").data("toggle");
            formulasDropdown(data_toggle, true);
        }
    });


    jQuery(".formulas-slider .slick-arrow").click(function () {
        if (jQuery(".slide-img").hasClass("slick-current")) {
            var data_toggle = jQuery(".slide-img.slick-current").data("toggle");
            formulasDropdown(data_toggle, true);
        }
    });

    jQuery(".mobile-formulas-dropdown span").click(function () {
        var $this = jQuery(this);
        $this.toggleClass("open-dropdown");
        $this.parent().find("ul").slideToggle(200, function () {
            jQuery(this).children().click(function () {
                var list_text = jQuery(this).text();
                $this.text(list_text);
                $this.removeClass("open-dropdown");
                jQuery(this).parent().hide();
                var data_id = jQuery(this).data("id");
                jQuery(".slide-img").each(function () {
                    var img_tigger = $(this);
                    var data_toggle = jQuery(this).data("toggle");
                    if (data_id == data_toggle) {
                        img_tigger.click();
                        img_tigger.addClass("slick-current").siblings().removeClass("slick-current");
                    }
                });

            });
        });
    });

});


/***Window Load***/
jQuery(window).load(function () {
    // Top adjestment of megamenu according header height
    // megamenuAdj();
    haircolorvideo_slider();
    haircolor_accordian();
    haircolor_autoplay();
    eyebrow_menu();
    desktopClass();
    // humber_menu();
    count_left_distunce();
    search_content_append();
    product_content_append();
    changeImageTitle();
    shade_list_function();
    // setTimeout(function(){
    // product_category_slider();
    // },300);
    // home_care_product_wrapper();

    equalHeights(".home-product-section .home-product-wrapper .home-product-outer .home-product-image");
    equalHeights(".home-product-section .home-product-wrapper .home-product-outer .home-product-content");
    equalHeights(".formulas-slider-nav .slide-img");
    equalHeights(".ing-details .ing-img");
    equalHeights(".product_care_item .product_care-inner");
    equalHeights(".product_care_item .home-product-inner-wrapper");
    equalHeights(".hair-care-matches-section .product-inner-wrapper .product-content-inner");
    equalHeights(".hair-care-matches-section .product-inner-wrapper .product-content-inner");
    // blog page
    setTimeout(function () {
        equalHeights(".blog-page .feature-grid-block h3");
        equalHeights(".upsell-modal .product_care_item .upsell-product-title h3");

    }, 3000);

    // ingredients glossary js
    findLastChild();
    checkChild();
    glossary_letters();
    stickyGlossary();

});

jQuery(window).on("orientationchange", function () {
    addTocart();
    desktopClass();
    desktop_menu();
    hair_color_tooltip_pos();
    hair_color_tooltip();
    setTimeout(function () {
        hideDots();
    }, 300);
});
/***Window Resize***/
jQuery(window).resize(function () {
    //    hair_shade_tabbing();
    hair_color_tooltip_pos();
    //for search
    if ($('.custom-select-dropdown select').length) {
        $('.custom-select-dropdown select').select2();
    }
    if ($('.search-input').length) {
        if ($(window).width() >= 1200) {
            $('.search-input').css('display', '');
        }
    }

    haircolor_accordian();
    haircolorvideo_slider();
    haircolor_autoplay();
    findLastChild();
    checkChild();
    if ($('.glossary-letters-listing.slick-slider').length) {
        $('.glossary-letters-listing').slick('resize');
    }
    glossary_letters();


    // Top adjestment of megamenu according header height
    eyebrow_menu();
    desktop_menu();
    hideDots();
    // megamenuAdj();
    desktopClass();
    search_content_append();
    product_content_append();
    // humber_menu();
    changeImageTitle();
    shade_list_function();
    count_left_distunce();
    homeproduct_Slider();
    homeabout_Slider();
    blog_Slider();
    cart_item_height();
    stickyGlossary();
    hair_color_tooltip();

    // setTimeout(function(){
    if ($('.product_care.slick-slider').length) {
        $(".product_care").slick('resize');
    }
    product_category_slider();
    // },200);

    // home_care_product_wrapper();

    equalHeights(".home-product-section .home-product-wrapper .home-product-outer .home-product-image");
    equalHeights(".home-product-section .home-product-wrapper .home-product-outer .home-product-content");
    equalHeights(".formulas-slider-nav .slide-img");
    equalHeights(".product_care_item .product_care-inner");
    equalHeights(".ing-details .ing-img");
    // setTimeout(function() {
    equalHeight();
    // }, 500);
    // equalHeights(".product_care_item .product-title");
    equalHeights(".product_care_item .home-product-inner-wrapper");
    equalHeights(".hair-care-matches-section .product-inner-wrapper .product-content-inner");
    addTocart();
    account_mble_menu();
    blog_mble_menu();
    // blog page
    equalHeights(".blog-page .feature-grid-block h3");
    setTimeout(function () {
        equalHeights(".upsell-modal .product_care_item .upsell-product-title h3");
    }, 3000);
});

// stickey header js

$(window).scroll(function () {
    // megamenuAdj();
    fix_header();
    eyebrow_menu();
    stickyGlossary();

    if ($('body').hasClass('stickey-header')) {
        var topPadding = $('.stickey-header header').height();
        $('.main-content').css("padding-top", topPadding + "px");
    } else {
        $('.main-content').css("padding-top", "0px");
    }
});


var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].hostname != '' && links[i].hostname != '#') {


        links[i].target = '_blank';
        links[i].relList.add('noreferrer', 'noopener');
    }
}

$('#Contact__Form__Zend').submit(function (e) {
    e.preventDefault();

    let form = $(this)

    if (form.find('input[name=email]').val() == form.find('input[name=verify_email]').val()) {
        $.ajax({
            url: 'https://zotos.zendesk.com/api/v2/requests',
            type: 'POST',
            crossDomain: true,
            headers: {
                "Authorization": "Basic bGluZHNheUBuZXdiaXJkZGVzaWduLmNvbS90b2tlbjp6ZzQ5SmRPOGQ2YWwwZm11ajVzblcyMERhZWZTTkxiQUszSUtGU2hP",
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                "request": {
                    "subject": "Contact Form",
                    "requester": {
                        "name": `${form.find('input[name=first_name]').val()} ${form.find('input[name=last_name]').val()}`,
                        "email": form.find('input[name=email]').val(),
                    },
                    "comment": {
                        "body": 'Name Surname: ' + form.find('input[name=first_name]').val() + ' ' + form.find('input[name=last_name]').val() + '\n' + 'Email: ' + form.find('input[name=email]').val() + '\n' + form.find('textarea[name=comment]').val(),
                    }
                }
            }),
            success: function () {
                form.find('#complete_message').text('Thank you for sending us your comments.')
                form.find('textarea, input[type!=submit]').val('')
            },
            error: function (err) {
                console.error(err);
                form.find('#complete_message').text('Something went wrong. Please try again.')
                form.find('#complete_message').css('color', 'red')
            },
        })
    } else {
        form.find('input[name=verify_email]').css('border-color', 'red')
    }
})

$('button.open-chat').on('click', e=> {
   zE('messenger', 'open');
})
// KLAVIYO ADD MEMBERS FOR NEWSLETTER LIST
const newsletterEndpoint = 'https://betternatured.herokuapp.com/https://a.klaviyo.com/api/v2/list/QsZmJ7/members?api_key=pk_ff38a8ba16593f2734c87e424ef4fffa38';
$('#RegisterForm .create-act-btn').on('click', e => {
    e.preventDefault();
    const options = {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
            profiles: { email: $('input#RegisterForm-email').val() }
        })
    };
    if ($('input#policyTerms').is(':checked')) {
        if ($('#subsCheck').is(':checked')) {
            fetch(newsletterEndpoint, options).then((response) => {
                const contentType = response.headers.get('content-type');
                if (!contentType || !contentType.includes('application/json')) {
                    throw new TypeError("Oops, we haven't got JSON!");
                }
                return response.json();
            })
                .then((data) => {
                    $('#RegisterForm').submit();
                })
                .catch((error) => console.error(error))
        } else {
            $('#RegisterForm').submit();
        }
    } else {
        document.querySelector('.policy-check-item-NB label').setAttribute('style', 'color: red !important');
        return false;
    }
})
$('#RegisterForm #policyTerms').change(
    function () {
        if ($(this).is(':checked')) {
            document.querySelector('.policy-check-item-NB label').setAttribute('style', '');
        } else {
            document.querySelector('.policy-check-item-NB label').setAttribute('style', 'color: red !important');
        }
    });
$('#SalonProfessional .button-block .black-btn').on('click', function (e) {
    e.preventDefault();
    if ($('#policyCheck').is(':checked')) {
        $('#SalonProfessional').submit();
    } else {
        $('.policy-check-item-NB label').attr('style', 'color:red!important');
    }
})